module.exports = __webpack_public_path__ + "img/device_point5-1.3e817529.png";